
import { generateToolSchema, TOOL_CATEGORIES } from "@/utils/schemaUtils";

export const getFairClickSchema = () => {
  return generateToolSchema({
    name: "FairClick",
    description: "Échangez des visites de manière éthique et gagnez du trafic en visitant les sites des autres",
    applicationCategory: TOOL_CATEGORIES.MARKETING,
    keywords: ["trafic", "visites", "échange", "web", "marketing"]
  });
};
